import styled from "styled-components"

export const StyledPortionOnly = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  border-radius: 8px;
  background-color: #fff;
`

export const PortionLabel = styled.div`
  font-size: 16px;
`

export const StyledUnit = styled.div`
  width: 80px;
  padding: 0px 4px;
  text-align: center;
  font-size: 16px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledPortionInput = styled.input`
  width: 80px;
  padding: 0px 4px;
  text-align: center;
  font-size: 16px;
  height: 44px;
  border: none;
  border-bottom: 1px solid var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));
  background: var(--Schemes-Surface-Container-Lowest, #fff);
  color: var(--Schemes-Primary, #0da3ba);
  &,
  &:focus,
  &:visited,
  &:active {
    outline: none;
    box-shadow: none;
  }
  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: var(--color-navy);
    opacity: 0.36;
    font-family: proxima-nova;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: var(--color-navy);
    opacity: 0.36;
    font-family: proxima-nova;
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`
